import { useEffect } from 'react';
import classes from '../../style.module.scss';

export const useMobileResize = ({ pickerContainerRef, isMobile, values }) => {
    useEffect(() => {
        if (!isMobile || !pickerContainerRef?.current) {
            return;
        }

        const topOffset = `${pickerContainerRef.current.offsetHeight + 1}px`;
        const container = pickerContainerRef.current.querySelector(
            `.${classes.suggestionsContainer}`
        );

        container.style.top = topOffset;
        container.style.height = `calc(100% - ${topOffset})`;
    }, [pickerContainerRef, isMobile, values]);
};
